import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography
} from '@mui/material';
import React, { FC, memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import DocManagementService from '../documentUpload/service/DocManagementService';

const ApprovalWorkflowDialog: FC<any> = ({
  openApproveDialog,
  setOpenApproveDialog,
  buttonText,
  setDisableButton,
  setIsSentToIsf,
  taskId,
  taskTitle
}: any) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const docService = new DocManagementService();
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const [comment, setComment] = useState('');
  const [isProcessing, setProcessing] = React.useState(false);
  const [issue, setIssue] = useState('');
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);

  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }
  const dispatch = useDispatch();
  const handleCloseRejectDialog = () => {
    setOpenApproveDialog(false);
  };

  const handleConfirmClick = async () => {
    setProcessing(true);
    const CompleteApprovalData = {
      action_name: 'Approve',
      sent_to_isf: false,
      is_resolved: true,
      updated_by: userName
    };
    const docData: any = {
      document_id: documentDetail.data[0].id,
      tmf_doc_viewer_req_certified_copy: documentDetail.data[0].tmf_doc_viewer_req_certified_copy,
      is_checkbox_verified: documentDetail.data[0]?.is_checkbox_verified,
      created_by: userName,
      is_submit: false
    };
    const UpdatedQCData = {
      tmf_doc_viewer_req_certified_copy: documentDetail.data[0].tmf_doc_viewer_req_certified_copy,
      tmf_doc_viewer_qc_issue_type: issue,
      tmf_doc_viewer_qc_issue_comments: comment,
      is_checkbox_verified: documentDetail.data[0]?.is_checkbox_verified,
      is_submit: false,
      id: documentDetail.data[0].tmf_quality_control_table_id,
      updated_by: userName
    };

    const RejectApprovalData = {
      user_name: '',
      user_email_id: 'user@example.com',
      action_name: 'Reject',
      reject_reason: comment,
      updated_by: userName
    };

    if (buttonText === 'Approval Reject') {
      const params = {
        module_section_related: 'DocumentRejected',
        parent_entity_related: documentDetail.data[0].tmf_document_name
      };
      let qcResponse: any;
      documentDetail.data[0]?.tmf_quality_control_table_id
        ? (qcResponse = await docService.updateQC(
            params,
            UpdatedQCData,
            TmfLevel,
            selectedStudy,
            selectedCountry,
            selectedSite
          ))
        : (qcResponse = await docService.CreateQC(
            params,
            docData,
            TmfLevel,
            selectedStudy,
            selectedCountry,
            selectedSite
          ));

      const response = await docService.RejectReview(
        documentDetail.data[0].task_Id ? documentDetail.data[0].task_Id : taskId,
        RejectApprovalData,
        params,
        selectedStudy,
        selectedCountry,
        selectedSite,
        TmfLevel
      );
      const data = {
        is_resolved: false,
        action_name: 'Reject',
        updated_by: userName
      };
      const result: any = await docService.updateStatus(
        documentDetail.data[0].task_Id ? documentDetail.data[0].task_Id : taskId,
        data,
        params,
        selectedStudy,
        selectedCountry,
        selectedSite,
        TmfLevel,
        false
      );
      if (response?.data && qcResponse?.data) {
        store.dispatch(setSnackbarMessage('Approve Rejected.', 'success'));
        setDisableButton(true);
        setDocumentDetail(dispatch, [
          {
            ...documentDetail.data[0],
            tmf_doc_status: 'Rejected',
            tmf_doc_viewer_qc_issue_type: issue,
            tmf_doc_viewer_qc_issue_comments: comment
          }
        ]);
      } else {
        store.dispatch(setSnackbarMessage('Error in rejecting.', 'error'));
      }
    } else {
      const params = {
        module_section_related: 'DocumentApproval',
        parent_entity_related: documentDetail.data[0].tmf_document_name
      };
      const result = await docService.completeApproval(
        documentDetail.data[0].task_Id ? documentDetail.data[0].task_Id : taskId,
        CompleteApprovalData,
        selectedStudy,
        selectedCountry,
        selectedSite,
        TmfLevel,
        params
      );

      const query = {
        query_filters: [
          {
            name: 'tmf_document_id',
            value: documentDetail?.data[0]?.tmf_document_id,
            operation: 'equals'
          }
        ],
        filter_types: ['All']
      };

      const param = {
        module_section_related: 'DocumentDetails',
        parent_entity_related: 'Metric Data'
      };

      const res: any = await docService.getGlobalSearch(
        query,
        selectedStudy,
        selectedCountry,
        selectedSite,
        TmfLevel,
        param
      );

      if (result.data) {
        store.dispatch(setSnackbarMessage('Approved successfully.', 'success'));
        setDisableButton(true);
        setIsSentToIsf(res?.data?.selected_data[0]?.need_to_sent_to_isf === 'Yes' ? false : true);
        setDocumentDetail(dispatch, [
          {
            ...documentDetail.data[0],
            tmf_doc_status: 'Approved',
            tmf_doc_approval_date: res?.data?.selected_data[0]?.document_data.tmf_doc_approval_date
          }
        ]);
      } else {
        store.dispatch(setSnackbarMessage('Error in approving.', 'error'));
      }
    }
    setProcessing(false);

    setOpenApproveDialog(false);
  };

  const handleComment = (e: any) => {
    setComment(e.target.value);
  };

  const handleChange = (event: SelectChangeEvent) => {
    setIssue(event.target.value);
  };
  return (
    <React.Fragment>
      <PopupComponent
        open={openApproveDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{buttonText === 'Approval Reject' ? 'Reject' : 'Approve'}</DialogTitle>
        <DialogContent>
          {isProcessing && (
            <Box sx={{ width: '100%' }} mb={2}>
              <LinearProgress />
            </Box>
          )}
          <DialogContentText id="alert-dialog-description">
            {buttonText === 'Approval Reject'
              ? `Are you sure you would like to reject this document?`
              : `Are you sure you want to approve this document?`}
          </DialogContentText>
          <br></br>
          <Typography style={{ fontWeight: 'bold' }}>
            {`'${documentDetail.data[0]?.tasks_title ? documentDetail.data[0]?.tasks_title?.trim() : taskTitle}'`}
            <span style={{ fontWeight: 200 }}>
              {''}
              {buttonText === 'Approval Reject'
                ? ' task will be send back to the uploader.'
                : ' task will be marked as completed.'}
            </span>
          </Typography>
          {buttonText === 'Approval Reject' ? (
            <Grid container>
              <Grid md={12}>
                <FormControl variant="standard" fullWidth>
                  <InputLabel id="demo-simple-select-standard-label" required={true}>
                    QC Issue Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={issue}
                    onChange={handleChange}
                  >
                    <MenuItem value="Metadata issue">Metadata issue</MenuItem>
                    <MenuItem value="Duplicate document">Duplicate document</MenuItem>
                    <MenuItem value="Translation required">Translation required</MenuItem>
                    <MenuItem value="Certification">Certification</MenuItem>
                    <MenuItem value="Signature issue">Signature issue</MenuItem>
                    <MenuItem value="Illegible">Illegible</MenuItem>
                    <MenuItem value="Incomplete document">Incomplete document</MenuItem>
                    <MenuItem value="Quality of document">Quality of document</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid md={12} sx={{ pt: 0.5 }}>
                <FormControl variant="standard" fullWidth>
                  <TextField
                    id="standard-basic"
                    label="QC Issue Comments"
                    variant="standard"
                    value={comment}
                    required
                    inputProps={{
                      maxLength: 100
                    }}
                    onChange={e => handleComment(e)}
                  />
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            ''
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRejectDialog} className="grey-btn" disabled={isProcessing}>
            CLOSE
          </Button>
          <Button
            onClick={() => handleConfirmClick()}
            autoFocus
            disabled={
              buttonText === 'Approval Reject'
                ? comment.trim() === '' || issue === ''
                  ? true
                  : false
                : false || isProcessing
            }
          >
            CONFIRM
          </Button>
        </DialogActions>
      </PopupComponent>
    </React.Fragment>
  );
};

export default memo(ApprovalWorkflowDialog);
